import { Lightning } from "@lightningjs/sdk";

export default class WatchNextThumbnail extends Lightning.Component {
    action: any;
    _progressAnim: any;
    _progressRunning: any;

    override _setup() { }

    static override _template() {
        return {
            w: (w: any) => w,
            h: (h: any) => h,
            rect: true,
            color: controlsBGColor,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 6 },
            NextVideoImage: {
                w: (w: any) => w,
                h: (h: any) => h,
                visible: true,
            },
            Label: {
                x: (w: any) => w / 2,
                y: (h: any) => h - 30,
                mount: 0.5,
                zIndex: 1,
                text: {
                    textColor: textBGColor,
                    text: "",
                    fontSize: 30,
                    fontFace: 'Black',
                },
            },
            ProgressFill: {
                w: 0,
                h: (h) => h,
                rect: true,
                color: 0x66ff0000,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 6 },
                visible: false
            },
            Stroke: {
                x: -2,
                y: -2,
                w: (w) => w + 4,
                h: (h) => h + 4,
                rect: true,
                color: 0x000000,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: 8,
                    stroke: 4,
                    strokeColor: 0xffffffff
                }
            }
        }
    }

    set imgSrc(src: string) {
        this._imgSrc = src;
        // this.tag("NextVideoImage").src = src;
        this.tag("NextVideoImage").texture = {
            type: Lightning.textures.ImageTexture,
            src: src,
            resizeMode: {type: 'contain', w: 300, h: 220, quality: 50 }
        };
    }

    set label(v: any) {
        if (v) {
            this.tag("Label").text.text = v;
        }
    }

    override _handleEnter() {
        this.action && this.fireAncestors(this.action);
    }

    override _init() {
        const w = this.w
        const h = this.h
        this._progressAnim = this.animation({
            duration: 10, // Duration in seconds
            actions: [
                {
                    t: 'ProgressFill',
                    p: 'w',
                    v: { 0: 0, 1: w }, // Animate width from 0 to full width

                }
            ]
        })
        // this._progressAnim.on('finish', ()=>this.signal('progressAnimFinished'))
    }
    startProgress() {
        if (!this._progressRunning) {
            this._progressRunning = true;
            this.tag('ProgressFill').w = 0;
            this._progressAnim.start();
            this._progressAnim.on('finish', () => {
                this._progressRunning = false;
            });
        }
    }

    pauseProgress() {
        this._progressAnim.pause()
        this._progressRunning = false;
    }

    resumeProgress() {
        this._progressAnim.resume()
    }

    resetProgress() {
        this._progressAnim.stop()
        this._progressRunning = false;
    }

    override _focus() {
        this.tag('Stroke').shader.strokeColor = controlsBGColorFocus;
        this.tag('ProgressFill').visible = true;
        this.tag("Label").text.textColor = textBGColorFocus;
    }

    override _unfocus() {
        this.tag('Stroke').shader.strokeColor = textBGColor
        this.tag('ProgressFill').visible = false;
        this.tag("Label").text.textColor = textBGColor;
    }

}

//const controlsBGColorFocus = 0xfff34966;
const controlsBGColorFocus = 0xffff0000;
//const controlsBGColor = 0xaa2c2c2c;
const controlsBGColor = 0xff000000;


const textBGColor = 0xffffffff;
const textBGColorFocus = 0xffffffff;
//d2d2d2